// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RXCW","buttons":"styles_buttons__2K_9B"};